import { useEffect, useState } from "react";
import { Button, FormControl, FormLabel, Input, Text, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useChangeEmailMutation } from "../hooks/useSettingsMutations";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function ChangeEmailSection({ currentEmail }: { currentEmail: string }) {
  const [t] = useTranslation();
  const [email, setEmail] = useState(currentEmail);
  const [password, setPassword] = useState("");
  const { mutate, isPending } = useChangeEmailMutation();

  useEffect(() => {
    setEmail(currentEmail);
  }, [currentEmail]);

  const handleSave = () => {
    if (email && email !== currentEmail && password) {
      mutate(
        { email, password },
        { onSuccess: () => setPassword("") },
      );
    }
  };

  const isChanged = email !== currentEmail;
  const isValid = EMAIL_REGEX.test(email);

  return (
    <VStack spacing={5} align="stretch">
      <Text fontSize="xl" fontFamily="heading" fontWeight={600} color="dune.dune">
        {t("screens.settings.changeEmail")}
      </Text>

      <FormControl>
        <FormLabel fontSize="sm" color="transparent.white.60">
          {t("screens.settings.emailAddress")}
        </FormLabel>
        <Input
          fontSize="16px"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={t("screens.settings.emailPlaceholder")}
        />
        <Text fontSize="xs" color="transparent.white.30" mt={1}>
          {t("screens.settings.emailHint")}
        </Text>
      </FormControl>

      <FormControl>
        <FormLabel fontSize="sm" color="transparent.white.60">
          {t("screens.settings.currentPassword")}
        </FormLabel>
        <Input
          fontSize="16px"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder={t("screens.settings.currentPasswordPlaceholder")}
        />
      </FormControl>

      <Button
        variant="primary"
        size="sm"
        onClick={handleSave}
        isLoading={isPending}
        isDisabled={!isChanged || !isValid || !password || isPending}
      >
        {t("screens.settings.updateEmail")}
      </Button>
    </VStack>
  );
}
